import { getCookieValue, deleteCookie } from "./cookies";

export const redirectAfterLogin = () => {
    const cookieName = 'fx_go_back_link';
    const returnUrl = getCookieValue(cookieName);
    if(!returnUrl) {
        return;
    }

    deleteCookie(cookieName, '/', window.location.hostname);
    window.location.replace(returnUrl);     
}
